import { OutsideLayout } from "../components/layout/OutsideLayout";

export const ValidityCheck = () => {
    return (
        <OutsideLayout>
            <div>Validity Check Page</div>
        </OutsideLayout>
    );
};
